<template>
  <HeaderContent title="InHouse Lists" />
  <!-- <ActionContent :filterDate="false" :cta="false" /> -->
  <ActionContent
    :cta="false"
    :filter-modal="false"
    @action="modal = !modal"
    @showFilter="modalFilter = !modalFilter"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    v-model:search="search"
    @search-query="handleSearch"
  />
  <ExtrachargeForm
    :modal="modalExtraCharge"
    :uuid="reservationUuid"
    :from="from"
    @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="getAll"
  />
  <InhouseStatistics title="In House Statistics" :data="statistics" />
  <InhouseDataTable
    :data="inhouses"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
  <InhouseFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
    @filter="handleFilter"
  />
  <InHouseForm :modal="modal" @update:modal="modal = $event" />
  <PaymentForm
    :modal="modalPayment"
    :uuid="reservationUuid"
    @update:modal="modalPayment = $event"
    @paid="handlePayment"
  />
  <CheckOutConfirm
    title="Check Out Confirmation"
    :uuid="reservationUuid"
    :data="guestInformation"
    :actionType="actionType"
    :modalConfirm="modalEarlyCheckOut"
    v-model="modalEarlyCheckOut"
    @confirmed="handleEarlyCheckout"
  >
    <template #body>
      <div class="guest-info text-start">
        <div>
          <!-- informasi tamu -->
          <div class="px-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Guest Information</p>
            <ul class="guest">
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">ID/Pasport</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.guest?.identity_number ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Name</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation.reservation?.guest?.fullname ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Contact</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold"
                  >0{{
                    guestInformation.reservation?.guest?.phone ?? "-"
                  }}</span
                >
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Check In</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(guestInformation?.check_in_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Check Out</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(guestInformation?.check_out_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Stay Duration</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  countDays(
                    guestInformation?.check_in_date,
                    guestInformation?.check_out_date,
                  )
                }}</span>
              </li>
            </ul>
          </div>

          <!-- Detail Tagihan -->
          <div class="p-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Billing Details</p>
            <ul class="billing">
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Type</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.room?.room_category?.name ??
                  "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Number</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.room?.code ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Rate</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(
                    guestInformation?.reservation?.room?.room_category
                      ?.low_season_price ?? 0,
                  )
                }}</span>
              </li>
              <li class="mb-1" style="list-style: none">
                <div class="d-flex gap-2 align-items-start">
                  <span class="fw-semibold">Extra Charge</span>
                  <span class="fw-semibold label">:</span>
                  <div class="extra-charges">
                    <div
                      v-if="
                        guestInformation?.reservation?.extracharge?.length === 0
                      "
                      class="fw-semibold"
                    >
                      -
                    </div>
                    <div
                      v-for="(item, index) in guestInformation?.reservation
                        ?.extracharge ?? []"
                      :key="index"
                      class="extra-charge-item fw-semibold"
                    >
                      {{ item?.extra_charge?.name }} (Qty: {{ item?.quantity }},
                      {{ formatIDR(item?.price ?? 0) }})
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb-1" style="list-style: none">
                <div class="d-flex gap-2 align-items-start">
                  <span class="fw-semibold">Payment</span>
                  <span class="fw-semibold label">:</span>
                  <div class="payments">
                    <div
                      v-if="
                        guestInformation?.reservation?.payment?.length === 0
                      "
                      class="fw-semibold"
                    >
                      -
                    </div>
                    <div
                      v-for="(item, index) in guestInformation?.reservation
                        ?.payment ?? []"
                      :key="index"
                      class="payment-item fw-semibold"
                    >
                      {{ item?.payment_type }} (Date:
                      {{ dateFormatter(item?.payment_date) }},
                      {{ formatIDR(item?.amount ?? 0) }})
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Total Payment</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(guestInformation?.reservation?.total_paid ?? 0)
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Payment Status</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.payment_status ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Outstanding Balance</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(
                    guestInformation?.reservation?.outstanding_balance ?? 0,
                  )
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </CheckOutConfirm>

  <BillResto
    title="Bill Resto"
    :uuid="reservationUuid"
    v-model="modalBillResto"
  />

  <FormMaintenance
    v-if="modalMaintenance"
    v-model="modalMaintenance"
    :data="dataMaintenance"
  ></FormMaintenance>

  <ExtendForm
    :modal="modalExtend"
    :item="dataExtend"
    @update:modal="modalExtend = $event"
    @addOrUpdate="getAll"
    @extendSuccess="handleExtendSuccess"
  ></ExtendForm>

  <ExtendInvoiceModal
    :modal="modalExtendInvoice"
    :item="extendInvoiceItem"
    :extend-info="extendInvoiceInfo"
    @update:modal="modalExtendInvoice = $event"
  />

  <CancelExtendForm
    :modal="modalCancelExtend"
    :item="cancelExtendItem"
    @update:modal="modalCancelExtend = $event"
    @addOrUpdate="getAll"
    @cancelSuccess="handleCancelExtendSuccess"
  />

  <ToastResponse
    v-model="toastResponse.toast"
    :text="toastResponse.text"
    :success="toastResponse.success"
  ></ToastResponse>
</template>

<script>
import { ref, inject, onMounted, watch, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import InhouseStatistics from "@/components/StatisticData.vue";
import InhouseFilter from "./InHouseFilter.vue";
import InHouseForm from "./InHouseForm.vue";
import InhouseDataTable from "@/components/DataTable.vue";
import iconInHouse from "../../../public/icons/home-location.svg";
// import iconDeluxe from "../../../public/icons/business-value.svg";
// import iconStudio from "../../../public/icons/space-station-moon.svg";
// import iconHoneymoon from "../../../public/icons/rings-wedding.svg";
// import iconFamily from "../../../public/icons/family-pants.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import CheckOutConfirm from "@/components/ModalDialog.vue";
import BillResto from "@/components/BillResto.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import FormMaintenance from "../room/FormMaintenance/FormMaintenance.vue";
import ExtendForm from "@/components/Extend/ExtendForm.vue";
import ExtendInvoiceModal from "@/components/Extend/ExtendInvoiceModal.vue";
import CancelExtendForm from "@/components/Extend/CancelExtendForm.vue";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

export default {
  components: {
    HeaderContent,
    ActionContent,
    InhouseFilter,
    InHouseForm,
    InhouseStatistics,
    InhouseDataTable,
    ExtrachargeForm,
    CheckOutConfirm,
    BillResto,
    PaymentForm,
    ToastResponse,
    FormMaintenance,
    ExtendForm,
    ExtendInvoiceModal,
    CancelExtendForm,
  },
  setup() {
    const repositories = inject("repositories");
    const inhouseRepository = repositories?.inhouse;
    const checkinRepository = repositories?.checkin;
    const staffRepository = repositories?.employee;
    const modal = ref(false);
    const modalExtraCharge = ref(false);
    const modalPayment = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalEarlyCheckOut = ref(false);
    const actionType = ref("");
    const adminLogin = ref({});

    const reservationUuid = ref(null);
    const currentPage = ref(1);
    //const inHouseData = ref(null);
    const inhouse = ref({});
    const inhouses = ref([]);
    const data = ref([]);
    const guestInformation = ref({});

    const from = ref("inhouse");

    const modalMaintenance = ref(false);
    const dataMaintenance = ref({});

    const modalExtend = ref(false);
    const dataExtend = ref(null);
    const modalBillResto = ref(false);

    const modalExtendInvoice = ref(false);
    const extendInvoiceItem = ref(null);
    const extendInvoiceInfo = ref(null);

    const openExtendForm = (row) => {
      dataExtend.value = null;
      nextTick(() => {
        dataExtend.value = row;
        modalExtend.value = true;
      });
    };

    const openExtendInvoice = (row, details = null) => {
      extendInvoiceItem.value = row;
      extendInvoiceInfo.value = details;
      modalExtendInvoice.value = true;
    };

    const handleExtendSuccess = (data) => {
      if (data && data.item) {
        openExtendInvoice(data.item, data.extend_details);
      }
    };

    const modalCancelExtend = ref(false);
    const cancelExtendItem = ref(null);

    const openCancelExtendModal = (row) => {
      cancelExtendItem.value = null;
      nextTick(() => {
        cancelExtendItem.value = row;
        modalCancelExtend.value = true;
      });
    };

    const handleCancelExtendSuccess = (data) => {
      getAll();
      toastResponse.value = {
        toast: true,
        text: data?.message || "Perpanjangan berhasil dibatalkan.",
        success: true,
      };
    };

    const toastResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "is_online",
        label: "",
        class: "text-center w-25",
        tdClass: "align-middle",
      },
      {
        key: "room_category",
        label: "Room Type",
        class: "text-center",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "reservation.room.code",
        label: "Room Number",
        class: "text-center",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "status_reservation",
        label: "Status",
        sortable: true,
      },
      {
        key: "reservation.guest.fullname",
        label: "Guest Name",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "check_in_date",
        label: "Check In",
        class: "text-left",
        tdClass: " align-middle",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "check_out_date",
        label: "Check Out",
        tdClass: " align-middle",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "days_left_calculated",
        label: "Days Left",
        class: "text-center",
        tdClass: " align-middle",
        sortable: false,
        formatter: (value, key, item) => {
          return daysLeft(item.check_out_date);
        },
      },

      {
        key: "action",
        label: "Actions",
        tdClass: " align-middle",
      },
    ]);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    function formatDate(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0",
      )}-${String(date.getDate()).padStart(2, "0")}`;
    }

    // function for calculate days left
    const daysLeft = (checkOutDate) => {
      if (!checkOutDate) return "-";
      const today = new Date();
      const checkOut = new Date(checkOutDate);
      // reset time
      today.setHours(0, 0, 0, 0);
      checkOut.setHours(0, 0, 0, 0);
      const diffTime = checkOut.getTime() - today.getTime();
      // convert to 1 day
      const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const daysLeft = days < 0 ? 0 : days;
      return daysLeft;
    };

    // const startDate = ref(getStartDate);
    // const endDate = ref(getCurrentDate);

    const startDate = ref(formatDate(date));
    const endDate = ref(formatDate(date));
    const search = ref("");
    const filterStatus = ref({
      status: null,
    });

    const statistics = ref([]);

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = "",
    ) => {
      const params = {};

      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.status = status;
      if (searchQuery) params.search = searchQuery;

      try {
        const res = await checkinRepository.getListInhouse(params);

        inhouses.value = res.data.data;
        const inHouseStatistics = res.data.statistics;

        statistics.value = Object.entries(inHouseStatistics).map(
          ([key, value]) => {
            return {
              label: "Total",
              key: key
                .replace("_", " ")
                .replace(/\b\w/g, (l) => l.toUpperCase()),
              value,
              color: key === "in_house" ? "success" : "primary",
              icon: iconInHouse,
            };
          },
        );
      } catch (err) {
        console.error(err);
      }
    };

    const getById = async (uuid) => {
      await inhouseRepository
        .getById(uuid)
        .then((res) => {
          modal.value = true;
          inhouse.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const formatCurrencyNumber = (val) => {
      const num = Number(val) || 0;
      return new Intl.NumberFormat("id-ID").format(num);
    };

    const formatDateReceipt = (dateInput) => {
      if (!dateInput) return "-";
      const d = new Date(dateInput);
      if (isNaN(d.getTime())) return String(dateInput);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    };

    const formatDateTimeReceipt = (dateInput) => {
      const d = dateInput ? new Date(dateInput) : new Date();
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const printExtraChargeReceipt = (item) => {
      const res = item?.reservation || item;
      const validCharges = (res?.extracharge || []).filter(
        (e) => Number(e.quantity) > 0,
      );

      if (!validCharges.length) {
        alert("Tidak ada data Extra Charge untuk dicetak.");
        return;
      }

      const guestName =
        res?.guest?.fullname || res?.guest_name || res?.guest?.name || "-";

      const reservationNumber = res?.number || item?.reservation_number || "-";
      const roomNumber = item?.room?.code || res?.room?.code || "-";
      const roomType =
        item?.room?.room_category?.name ||
        res?.room?.room_category?.name ||
        "-";
      const checkInDate = formatDateReceipt(item.check_in_date || res.start);
      const checkOutDate = formatDateReceipt(item.check_out_date || res.end);
      const currentDate = formatDateTimeReceipt(new Date());

      const cashierName =
        adminLogin.value?.fullname ||
        adminLogin.value?.name ||
        adminLogin.value?.username ||
        "Cashier";

      let totalExtraCharge = 0;
      let totalPaidOnRes = 0;
      let remainingBill = 0;
      let itemsHtml = "";

      validCharges.forEach((c, index) => {
        const itemName = c.extra_charge?.name || "Extra Charge";
        const qty = Number(c.quantity) || 1;
        const price = Number(c.price ?? c.extra_charge?.price ?? 0);
        const subtotal = qty * price;
        const isPaid = !c.is_late_added;

        totalExtraCharge += subtotal;
        if (isPaid) {
          totalPaidOnRes += subtotal;
        } else {
          remainingBill += subtotal;
        }

        const statusBadge = isPaid
          ? '<span style="display:inline-block; padding: 2px 6px; font-size: 11px; font-weight: bold; color: #155724; background-color: #d4edda; border: 1px solid #c3e6cb; border-radius: 3px;">PAID (Reservation)</span>'
          : '<span style="display:inline-block; padding: 2px 6px; font-size: 11px; font-weight: bold; color: #856404; background-color: #fff3cd; border: 1px solid #ffeeba; border-radius: 3px;">UNPAID (In-House)</span>';

        itemsHtml += `
          <tr>
            <td style="text-align: center; border: 1px solid #000; padding: 6px 8px;">${
              index + 1
            }</td>
            <td style="border: 1px solid #000; padding: 6px 8px;">${itemName}</td>
            <td style="text-align: center; border: 1px solid #000; padding: 6px 8px;">${statusBadge}</td>
            <td style="text-align: center; border: 1px solid #000; padding: 6px 8px;">${qty}</td>
            <td style="text-align: right; border: 1px solid #000; padding: 6px 8px;">Rp ${formatCurrencyNumber(
              price,
            )}</td>
            <td style="text-align: right; border: 1px solid #000; padding: 6px 8px;">Rp ${formatCurrencyNumber(
              subtotal,
            )}</td>
          </tr>
        `;
      });

      const filename = `BILL-EXTRACHARGE-${reservationNumber}`;

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.setAttribute(
        "sandbox",
        "allow-modals allow-same-origin allow-scripts",
      );
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;

      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${filename}</title>
            <meta name="viewport" content="width=device-width,initial-scale=1.0">
            <style>
              @page {
                size: A4 portrait;
                margin: 8mm 15mm 0 15mm;
              }
              * {
                box-sizing: border-box;
              }
              body {
                font-family: Arial, sans-serif;
                font-size: 13px;
                color: #000;
                background: #fff;
                margin: 0;
                padding: 0;
                line-height: 1.35;
              }
              .text-center { text-align: center; }
              .text-right { text-align: right; }
              .text-left { text-align: left; }
              .fw-bold { font-weight: bold; }

              .header-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 4px;
              }
              .header-table td {
                vertical-align: middle;
                border: none;
                padding: 0;
              }
              .hotel-logo {
                width: 55px;
                height: auto;
              }
              .hotel-name {
                font-size: 17px;
                font-weight: bold;
                letter-spacing: 0.5px;
                margin-bottom: 2px;
              }
              .hotel-sub {
                font-size: 11px;
                color: #333;
                margin: 0;
                line-height: 1.3;
              }
              .header-divider {
                border: none;
                border-top: 1.5px solid #000;
                margin: 6px 0 8px 0;
              }
              .doc-title {
                text-align: center;
                font-size: 15px;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin-bottom: 10px;
              }

              .info-container {
                width: 100%;
                margin-bottom: 8px;
              }
              .info-table {
                width: 100%;
                border-collapse: collapse;
                font-size: 12.5px;
              }
              .info-table td {
                padding: 2px 0;
                vertical-align: top;
                border: none;
              }
              .info-label {
                width: 115px;
                color: #222;
              }
              .info-colon {
                width: 12px;
                text-align: center;
              }

              .items-table {
                width: 100%;
                border-collapse: collapse;
                font-size: 12.5px;
                margin-top: 4px;
                margin-bottom: 6px;
              }
              .items-table th {
                border: 1px solid #000;
                background-color: #f2f2f2;
                padding: 6px 8px;
                font-weight: bold;
                text-align: center;
              }
              .items-table td {
                border: 1px solid #000;
                padding: 6px 8px;
              }

              .total-table {
                width: 100%;
                border-collapse: collapse;
                font-size: 12.5px;
                margin-top: 4px;
              }
              .total-table td {
                border: 1px solid #000;
                padding: 6px 8px;
              }

              .signature-container {
                width: 100%;
                margin-top: 12px;
                page-break-inside: avoid;
                font-size: 12.5px;
              }
              .sig-box {
                width: 45%;
                text-align: center;
                display: inline-block;
                vertical-align: top;
              }
              .sig-space {
                height: 32px;
              }
              .footer-note {
                text-align: center;
                font-size: 11px;
                font-style: italic;
                margin-top: 10px;
                color: #555;
              }
            </style>
          </head>
          <body>
            <!-- Kop Surat Resmi -->
            <table class="header-table">
              <tr>
                <td style="width: 60px; text-align: center;">
                  <img src="/img/hotel-deliriver.png" alt="Deli River Hotel Logo" class="hotel-logo" />
                </td>
                <td style="padding-left: 12px;">
                  <div class="hotel-name">HOTEL DELI RIVER</div>
                  <div class="hotel-sub">Restaurant Omlandia</div>
                  <div class="hotel-sub">Jl. Raya Namorambe No. 129, Deli Tua, Medan, Sumatera Utara 20356</div>
                  <div class="hotel-sub">Tel: (061) 7032964 / 7032967 | Web: www.hotel-deliriver.com | Email: contact@hotel-deliriver.com</div>
                </td>
              </tr>
            </table>

            <div class="header-divider"></div>

            <div class="doc-title">Extra Charge Bill</div>

            <!-- Detail Reservasi / Tamu -->
            <div class="info-container">
              <table style="width: 100%; border-collapse: collapse;">
                <tr>
                  <td style="width: 50%; vertical-align: top; border: none; padding-right: 15px;">
                    <table class="info-table">
                      <tr>
                        <td class="info-label">Guest Name</td>
                        <td class="info-colon">:</td>
                        <td class="fw-bold">${guestName}</td>
                      </tr>
                      <tr>
                        <td class="info-label">Res. Number</td>
                        <td class="info-colon">:</td>
                        <td class="fw-bold">${reservationNumber}</td>
                      </tr>
                      <tr>
                        <td class="info-label">Room Number</td>
                        <td class="info-colon">:</td>
                        <td>${roomNumber} ${
        roomType !== "-" ? `(${roomType})` : ""
      }</td>
                      </tr>
                    </table>
                  </td>
                  <td style="width: 50%; vertical-align: top; border: none; padding-left: 15px;">
                    <table class="info-table">
                      <tr>
                        <td class="info-label">Invoice Date</td>
                        <td class="info-colon">:</td>
                        <td>${currentDate}</td>
                      </tr>
                      <tr>
                        <td class="info-label">Check In</td>
                        <td class="info-colon">:</td>
                        <td>${checkInDate}</td>
                      </tr>
                      <tr>
                        <td class="info-label">Check Out</td>
                        <td class="info-colon">:</td>
                        <td>${checkOutDate}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>

            <!-- Tabel Item Extra Charge -->
            <table class="items-table">
              <thead>
                <tr>
                  <th style="width: 35px;">No</th>
                  <th>Description / Item</th>
                  <th style="width: 150px;">Payment Status</th>
                  <th style="width: 60px;">Qty</th>
                  <th style="width: 130px;">Price</th>
                  <th style="width: 140px;">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="5" style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; background-color: #f9f9f9;">
                    Total Extra Charge
                  </td>
                  <td style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; background-color: #f9f9f9;">
                    Rp ${formatCurrencyNumber(totalExtraCharge)}
                  </td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; color: #155724; background-color: #e8f5e9;">
                    Paid on Reservation (Full Payment)
                  </td>
                  <td style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; color: #155724; background-color: #e8f5e9;">
                    Rp ${formatCurrencyNumber(totalPaidOnRes)}
                  </td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; color: #d32f2f; background-color: #ffebee; font-size: 13.5px;">
                    Remaining Bill to Pay (In-House)
                  </td>
                  <td style="text-align: right; font-weight: bold; padding: 6px 8px; border: 1px solid #000; color: #d32f2f; background-color: #ffebee; font-size: 13.5px;">
                    Rp ${formatCurrencyNumber(remainingBill)}
                  </td>
                </tr>
              </tfoot>
            </table>

            <!-- Tanda Tangan -->
            <div class="signature-container">
              <table style="width: 100%; border-collapse: collapse; margin-top: 6px;">
                <tr>
                  <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                    <div>Guest</div>
                    <div style="height: 28px;"></div>
                    <div>( ${guestName} )</div>
                  </td>
                  <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                    <div>Front Office</div>
                    <div style="height: 28px;"></div>
                    <div>( ${cashierName} )</div>
                  </td>
                </tr>
              </table>
            </div>

            <div class="footer-note">
              Thank you for visiting Deli River Hotel & Restaurant Omlandia
            </div>
          </body>
        </html>
      `);
      doc.close();

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 1000);
      };
    };

    const customActions = ref([
      {
        label: "Extra Charge",
        variant: "warning",
        icon: "fas fa-bolt",
        action: (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalExtraCharge.value = true;
        },
      },
      {
        label: "Print Extracharge",
        variant: "info",
        icon: "fas fa-print",
        disabled: (item) => {
          const res = item?.reservation || item;
          return !(
            res?.extracharge &&
            res.extracharge.filter((e) => Number(e.quantity) > 0).length > 0
          );
        },
        action: (item) => {
          printExtraChargeReceipt(item);
        },
      },
      {
        label: "Order",
        variant: "primary",
        icon: "fas fa-utensils",
        action: async (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalBillResto.value = true;
        },
      },
      {
        label: "Set Maintenance",
        variant: "danger",
        icon: "fas fa-wrench",
        action: (item) => {
          dataMaintenance.value = { item };
          modalMaintenance.value = true;
        },
      },
      {
        label: "More Options",
        variant: "secondary",
        icon: "fas fa-caret-square-down", // atau icon dropdown
        isDropdown: true,
        actions: [
          {
            label: "Extend Stay",
            icon: "fas fa-calendar-plus",
            action: (item) => {
              openExtendForm(item);
            },
          },
          {
            label: "Print Extend Invoice",
            icon: "fas fa-print",
            action: (item) => {
              openExtendInvoice(item);
            },
          },
          {
            label: "Batal Extend",
            icon: "fas fa-undo",
            disabled: (item) => {
              const res = item?.reservation || item;
              return !(res?.add_on === "extend" || Number(res?.days) > 1);
            },
            action: (item) => {
              openCancelExtendModal(item);
            },
          },
          {
            label: "Early Checkout",
            icon: "fas fa-sign-out-alt",
            action: (item) => {
              reservationUuid.value = item.reservation.uuid;
              guestInformation.value = item;

              if (item.reservation.is_paid) {
                actionType.value = "early-checkout";
                modalEarlyCheckOut.value = true;
              } else {
                modalPayment.value = true;
              }
            },
          },
        ],
      },
    ]);

    const refreshGuestInfo = async (uuid) => {
      try {
        await getAll(); // Refresh semua data in-house dari server

        const updatedGuest = inhouses.value.find(
          (item) => item.reservation?.uuid === uuid,
        );

        if (updatedGuest) {
          guestInformation.value = { ...updatedGuest };
        } else {
          console.warn("Guest with UUID not found after refresh:", uuid);
        }
      } catch (err) {
        console.error("Error refreshing guest info:", err);
      }
    };

    const handlePayment = async () => {
      await refreshGuestInfo(reservationUuid.value);
      modalPayment.value = false;
      if (guestInformation.value.reservation.is_paid) {
        modalEarlyCheckOut.value = true;
      }
    };

    const handleEarlyCheckout = (actionType) => {
      if (actionType.type === "early-checkout") {
        setCheckout(actionType.uuid);
      }
    };

    const setCheckout = async (uuid) => {
      try {
        await checkinRepository.checkOut(uuid).then((response) => {
          getAll();
          modalEarlyCheckOut.value = false;

          toastResponse.value = {
            toast: true,
            success: true,
            text: response?.data?.message || "Guest checked out successfully",
          };
        });
      } catch (e) {
        console.log(e);

        toastResponse.value = {
          toast: true,
          success: false,
          text: e.response?.data?.error || "Something went wrong!",
        };
      }
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    const handleSearch = (query) => {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    };

    watch([startDate, endDate, filterStatus, search], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value,
      );
    });

    const getAdminByUuid = async () => {
      try {
        const localUser = localStorage.getItem("user");
        if (localUser) {
          const user = JSON.parse(localUser);
          const uuid = user.employee_uuid;
          if (uuid && staffRepository) {
            const res = await staffRepository.getById(uuid);
            adminLogin.value = res.data.data;
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    onMounted(() => {
      getAll();
      const localUser = localStorage.getItem("user");
      if (localUser) {
        const user = JSON.parse(localUser);
        if (user.role !== "superadmin") {
          getAdminByUuid();
        }
      }
    });

    return {
      getAll,
      getById,
      filterStatus,
      handleFilter,
      handleSearch,
      handleEarlyCheckout,
      handlePayment,
      search,
      getStartDate,
      getCurrentDate,
      startDate,
      endDate,
      reservationUuid,
      modal,
      modalPayment,
      modalEarlyCheckOut,
      modalExtraCharge,
      modalFilter,
      modalConfirm,
      modalBillResto,
      guestInformation,
      refreshGuestInfo,
      data,
      from,
      headers,
      statistics,
      inhouse,
      inhouses,
      currentPage,
      customActions,
      actionType,
      formatIDR,
      dateFormatter,
      countDays,
      toastResponse,
      modalMaintenance,
      dataMaintenance,
      modalExtend,
      dataExtend,
      modalExtendInvoice,
      extendInvoiceItem,
      extendInvoiceInfo,
      handleExtendSuccess,
      modalCancelExtend,
      cancelExtendItem,
      openCancelExtendModal,
      handleCancelExtendSuccess,
      daysLeft,
    };
  },
};
</script>

<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.payments {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.payment-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #00f974;
}
</style>
